import { setToken } from 'lib/common'
import { globalConst as native, mutationNames } from 'lib/const'
import { isEmptyObject, margeMutations, hexToUTF8Str } from 'lib/utils'
import { applyClientMiddleware } from 'src/main'
import api from 'api/api'
import PackageFile from 'lib/packageFile'
import { createModule } from 'plugins/vuex-request/VuexModule'

const state = {
  chkcode: '',
  imbcode: '',
  listFile: [],
  recordingList: [],
  mp3List: [],
  installListFile: [],
  process: {
    value: 0,
    hasTask: 0,
    downLoadFile: '',
    fileName: '',
    packId: -1,
    downLoadText: '下载'
  },
  downLoaderServerUrl: '',
  macAddr: '',
  pollTask: null
}

const getters = {}
const actions = {
  [native.reboot] ({state}, refs) {
    return applyClientMiddleware(api.reboot, refs)
  },
  [native.softwareUpdateProcess] ({state}, refs) {
    return applyClientMiddleware(api.softwareUpdateProcess, refs)
  },
  [native.softwareUpdate] ({state}, refs) {
    return applyClientMiddleware(api.softwareUpdate, refs)
  },
  [native.getVersion] ({state}, refs) {
    return applyClientMiddleware(api.getVersion, refs)
  },
  [native.getDevice] ({state}, refs) {
    return applyClientMiddleware(api.getDevice, refs)
  },
  async [native.downLoad] ({state, dispatch}, refs) {
    const {baseUrl} = refs
    await dispatch({
      type: native.queryDownLoadProcess,
      baseUrl
    })
    const processComplate = 100
    if (!state.process.hasTask || state.process.value === processComplate) {
      return applyClientMiddleware(api.downLoad, refs)
    } else {
      return Promise.reject('当前有下载任务')
    }

  },
  [native.listFile] ({state}, refs) {
    return applyClientMiddleware(api.listFile, refs)
  },
  [native.readBlock] ({state}, refs) {
    return applyClientMiddleware(api.readBlock, refs)
  },
  [native.writeBlock] ({state}, refs) {
    return applyClientMiddleware(api.writeBlock, refs)
  },
  [native.rename] ({state}, refs) {
    return applyClientMiddleware(api.rename, refs)
  },
  [native.queryDownLoadProcess] ({state}, refs) {
    return applyClientMiddleware(api.queryDownLoadProcess, refs)
  },
  [native.delFile] ({state}, refs) {
    return applyClientMiddleware(api.delFile, refs)
  },
  [native.readEncryption] ({state}, refs) {
    return applyClientMiddleware(api.readEncryption, refs)
  },
  [native.readSerial] ({state}, refs) {
    return applyClientMiddleware(api.readSerial, refs)
  },
  [native.readBeforeThreeBit] ({state}, refs) {
    return applyClientMiddleware(api.readBeforeThreeBit, refs)
  }
}
let mutations = {
  setMacAddr (state, macAddr) {
    state.macAddr = macAddr
  },
  setDownLoaderServerUrl (state, downLoaderServiceUrl) {
    state.downLoaderServerUrl = downLoaderServiceUrl
  },
  [mutationNames.queryDownLoadProcess_success] (state, {data, refs}) {
    let {hasTask, processBar, downLoadFile} = data
    state.process.hasTask = hasTask
    state.process.value = processBar
    if (hasTask) {
      state.process.downLoadFile = downLoadFile
    } else {
      state.process.packId = -1
    }
  },
  [native.readBlock] (state, {data, otherConfig}) {
    console.log('readBalock 回调成功', data, otherConfig)
  },
  [`${native.readEncryption}_cache`] (state) {
    return state.encription !== ''
  },
  [mutationNames.readEncryption_success] (state, {data, otherConfig}) {
    state.chkcode = hexToUTF8Str(data)
    console.log('加密文件：', state.chkcode)
  },
  [mutationNames.readSerial_success] (state, {data, otherConfig}) {
    let number = hexToUTF8Str(data).replace(/[\r\n]/g, '').replace(/\s+/g, '')
    console.log('序列号：', number)
    state.imbcode = number
  },
  clearListFile (state) {
    state.listFile = []
    state.mp3List = []
    state.recordingList = []
    state.installListFile = []
  }
}
mutations = Object.assign(margeMutations(actions), mutations)
export default createModule(state, getters, actions, mutations, false)
